import React, { useEffect, useState } from 'react'
import { Button, Col, Divider, Form, Input, message, Row, Select } from 'antd'
import { Grid } from '@material-ui/core'
import PageHeader from '../../Components/PageHeader'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { ErrorMessages, showText } from '../../helpers/textValidation'
import { getAllLocomotive, getAllNotesWorkOrder, getWorkOrderById, updateApproval, updateStatus, updateWorkOrderById } from '../../Services/LocomotiveServices'
import { CaretLeftOutlined, ConsoleSqlOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import services from '../../Services'
import moment from 'moment'
import { Colors } from '../../helpers/Colors'
import { DownloadPdfWorkOrder, TableWoDelete, get_site_listing } from '../../Services/employee'
import LocomotiveWorkOrderModal from '../../Components/Modals/LocomotiveWorkOrderModal'
import NotesModalUpdated from '../../Components/Modals/NotesModalUpdated'
import LocomotiveTable from './LocomotiveTable'
import WoOrderModalNC from '../../Components/Modals/WoOrderModal'
import roleManager from '../../Components/roles'
import ConfirmModal from './Modal/ConfirmModal'
import AcceptModal from './Modal/AcceptModal'
import ModalDeleteWoTable from '../../Components/Modals/ModalDeleteWoTable'
import { seriliazeParams } from '../../helpers/seriliazeParams'
import PageLayout from '../../Components/LayoutComponents/PageLayout'
import LastTaskCompletedModal from './Modal/LastTaskCompleted.modal'
import TicketCategoryModals from './Modal/TicketCategory.modal'
import WODescriptionModal from './Modal/WODescription.modal'
import WOAssignedToModal from './Modal/WOAssignTo.modal'
import DateScheduledModal from './Modal/DateScheduled.modal'
import { haveAccessByRole } from '../../helpers'

const LocomotiveWorkOrderEdit = () => {


    const history = useHistory()
    const { state, data } = useLocation()

    const { hr } = services;
    const { TextArea } = Input;
    const { location } = history

    const [Data, setData] = useState({})
    const [isModalsOpen, setIsModalsOpen] = useState({
        ticket_Category: false,
        wo_Discription: false,
        wo_Assigned_To: false,
        wo_Schedule_Date: false,
        last_Task_Completed: false,
    })
    const [workOrderByID, setWorkOrderByID] = useState({})
    const [reloadPageByNotesModal, setReloadPageByNotesModal] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [modalData, setModalData] = useState()
    const [isLastTaskModalOpen, setIsLastTaskModalOpen] = useState(false)
    const [notesData, setNotesData] = useState([]);
    const [isModalOpenNotes, setIsModalOpenNotes] = useState(false);
    const [reload, setReload] = useState(false);
    const [workOrderData, setWorkOrderData] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedCauseCode, setSelectedCauseCode] = useState(null);
    const [allUsers, setAllUsers] = useState([])
    const [ticketId, setTicketId] = useState()
    const [isModalOpenDeleteTable, setIsModalOpenDeleteTable] = useState(false);
    const [updateData, setUpdateData] = useState();
    const [showDeleteWo, setShowDeleteWo] = useState();
    const [mode, setMode] = useState(location.state.pageMode)
    const [apiData, setApiData] = useState(null);
    const [refreshState, setRefreshState] = useState(false);
    const [reloadState, setReloadState] = useState(false)
    const [allSelectedCauseCodes, setAllSelectedCauseCodes] = useState([])

    const id = location?.state?.id;

    const CheckDeleteWo = async () => {
        try {
            const response = await TableWoDelete(id);
            setShowDeleteWo(response?.data);
        } catch (error) {
            console.error('Error fetching data from API:', error);
        }
    };


    const ShowDeleteTable = async () => {
        try {
            setIsModalOpenDeleteTable(true);
            const response = await TableWoDelete(id);
            setUpdateData(response?.data);
            setApiData(data);

        } catch (error) {
            console.error('Error fetching data from API:', error);
        }
    };

    const DeleteTablehandleOk = () => {
        setIsModalOpenDeleteTable(false);
    };
    const DeleteTablehandleCancel = () => {
        setIsModalOpenDeleteTable(false);
    };

    const openNotesModal = () => {
        setIsModalOpenNotes(true);
    };

    const closeModalNotes = () => {
        setIsModalOpenNotes(false);
    };


    const Fields = [
        {
            name: "WO ID",
            key: "wo_Id",
            type: "Number",
            required: true,
            edit: false,
            show: true

        },
        {
            name: "Date Created",
            key: "date_Created",
            type: "Text",
            required: true,
            edit: false,
            show: true

        },
        {
            name: "Created By",
            key: "created_By",
            type: "Text",
            required: false,
            edit: false,
            show: true
        },
        {
            name: "Ticket ID",
            key: "ticket_Id",
            type: "Text",
            required: true,
            edit: false,
            show: true,
            action: mode === "view-only" ? "" : 'redirect'
        },
        {
            name: "Location",
            key: "location",
            type: "Text",
            required: true,
            edit: false,
            show: true
        },
        {
            name: "Status",
            key: "Status",
            type: "Text",
            required: true,
            edit: false,
            show: true
        },
        {
            name: "Ticket Category",
            key: "ticket_Category",
            type: "Text",
            required: true,
            edit: mode === "view-only" ? false : roleManager("LocomotiveWorkOrder", "sections", "TicketCategory"),
            show: true
        },
        {
            name: "Ticket Comments",
            key: "ticket_Comments",
            type: "Text",
            required: false,
            edit: false,
            show: true
        },
        {
            name: "WO Description",
            key: "wo_Discription",
            type: "Text",
            required: true,
            edit: mode === "view-only" ? false : true,
            show: true,
        },
        {
            name: "WO Assigned To",
            key: "wo_Assigned_To",
            type: "Text",
            required: true,
            edit: mode === "view-only" ? false : true,
            show: true
        },
        {
            name: "Date Scheduled",
            key: "wo_Schedule_Date",
            type: "Text",
            required: true,
            edit: mode === "view-only" ? false : true,
            show: true
        },
        {
            name: "Last Task Completed",
            key: "last_Task_Completed",
            type: "Text",
            required: true,
            edit: mode === "view-only" ? false : roleManager("LocomotiveWorkOrder", "sections", "TicketCategory"),
            show: true
        },

    ]

    console.log(roleManager("LocomotiveWorkOrder", "sections", "TicketCategory"), "role");


    const contractormap = (data) => {
        if (data) {
            let {
                firstName,
                lastName,
                Company
            } = data;

            let output = '';

            if (Company)
                output = Company;

            if (Company && firstName && lastName)
                output = output + "-"

            if (firstName && lastName)
                output = `${output} ${firstName} ${lastName[0]}.`

            return output;
        }

        return 'N/A'

    };


    const getWorkOrder = async () => {
        const result = await getWorkOrderById(id);
        if (result?.httpStatus === 200) {
            setWorkOrderByID({
                equip_Id: result?.data?.EquipMaster?.EquipUID,
                loco_Model: result?.data?.EquipMaster?.Loco_Model,
                current_Status: 'Not Available',
                wo_Id: result?.data?.id,
                location: result?.data?.TGSLocation?.name,
                source: showText(result?.data?.TicketSource?.name),
                closeoutreason: result?.data?.TicketClose?.CloseType,
                date_Created: moment?.utc(result?.data?.createdAt).format("MM-DD-YYYY HH:mm:ss"),
                created_By: (result?.data?.Createdby?.firstName ?? "N/A") + " " + (result?.data?.Createdby?.lastName || ""),
                Status: result?.data?.Status,
                ticket_Id: result?.data?.TckId,
                location: result?.data?.TGSLocation?.name,
                ticket_Category: result?.data?.Ticket?.TicketCategory?.name,
                ticket_Comments: result?.data?.Ticket?.comment,
                wo_Assigned_To: (result?.data?.Assignedto?.firstName ?? contractormap(result?.data?.AssignedtoContractor) ?? "N/A") + " " + (result?.data?.Assignedto?.lastName ?? ""),
                wo_Schedule_Date: result?.data?.ScheduleDate ? moment(result?.data?.ScheduleDate)?.utc()?.format("MM-DD-YYYY") : "N/A",
                wo_Discription: result?.data?.Description,
                // last_Task_Completed: result?.data?.LatestCompletedTask?.length > 0 ? result?.data?.LatestCompletedTask?.[0]?.WorkCompleted ? moment(result?.data?.LatestCompletedTask?.[0]?.WorkCompleted)?.utc()?.format("MM-DD-YYYY") : "N/A" : "N/A"
                last_Task_Completed: result?.data?.LatestCompletedTask?.length > 0
                    ? result?.data?.LatestCompletedTask?.[0]?.WorkCompleted
                        ? moment(result?.data?.LatestCompletedTask?.[0]?.WorkCompleted)?.utc()?.format("MM-DD-YYYY")
                        : "N/A"
                    : result?.data?.LatestClosedTask?.length > 0
                        ? result?.data?.LatestClosedTask?.[0]?.WorkCompleted
                            ? moment(result?.data?.LatestClosedTask?.[0]?.WorkCompleted)?.utc()?.format("MM-DD-YYYY")
                            : "N/A"
                        : "N/A"
            })
            setData(result?.data)

        }
        setTicketId(result?.data?.TckId);

    }



    const handleStatus = async (action) => {

        try {
            let payload = {};
            if (action == "complete") {
                let hasNull = false
                workOrderData.forEach(item => {
                    if (!item?.Category || !item?.SubCategory || !item.TaskId)
                        hasNull = true
                });
                if (hasNull)
                    return message.error('Kindly Fill the fields and save it')

                payload = { complete: true }
            } else if (action == "accept") {
                if (!allSelectedCauseCodes?.length && !selectedCauseCode) return message.error("Select Clouseout Code or Select cause codes by tasks")
                payload = { accept: true, causeCode: selectedCauseCode };
            } else if (action == "reject") {
                payload = { reject: true };
            }

            const result = await updateStatus(id, payload);

            if (result?.httpStatus === 200) {
                message.success('Updated Successfully!');

                if (action == "complete" && result?.data?.locoOutOfService) {
                    setIsModalOpen(true);
                }
                if (action == "accept") history.push("/Locomotiveworkorders")
                setRefreshState((prevState) => !prevState);
                setReload(!reload);

            } else {
                message.error('Not updated!');
            }
        } catch (error) {
            message.error('An error occurred while updating status.');
        }
    };


    const ConfirmModalSubmit = async () => {

        const payload = {
            "EquipID": Data?.EquipID,// Replace with the actual Equipment ID
            "WO_ID": Data?.id
        };
        const dataConfirm = await updateApproval(payload);
        if (dataConfirm?.httpStatus === 200) {
            message.success('Updated Successfully!');
            setIsModalOpen(false);
            setRefreshState((prevState) => !prevState);
        }

    };

    // const HandleModal = (key) => {
    //     if (key === "last_Task_Completed") return setIsLastTaskModalOpen(true)
    //     else return setOpenModal(!openModal)
    // }

    const onClickEditInfo = (key) => {
        let map = {
            ticket_Category: () => setIsModalsOpen(prev => { return { ...prev, ticket_Category: true } }),
            wo_Discription: () => setIsModalsOpen(prev => { return { ...prev, wo_Discription: true } }),
            wo_Assigned_To: () => setIsModalsOpen(prev => { return { ...prev, wo_Assigned_To: true } }),
            wo_Schedule_Date: () => setIsModalsOpen(prev => { return { ...prev, wo_Schedule_Date: true } }),
            last_Task_Completed: () => setIsModalsOpen(prev => { return { ...prev, last_Task_Completed: true } })
        }
        return map[key]()
    }

    const onCloseModals = (key) => {
        let map = {
            ticket_Category: () => setIsModalsOpen(prev => { return { ...prev, ticket_Category: false } }),
            wo_Discription: () => setIsModalsOpen(prev => { return { ...prev, wo_Discription: false } }),
            wo_Assigned_To: () => setIsModalsOpen(prev => { return { ...prev, wo_Assigned_To: false } }),
            wo_Schedule_Date: () => setIsModalsOpen(prev => { return { ...prev, wo_Schedule_Date: false } }),
            last_Task_Completed: () => setIsModalsOpen(prev => { return { ...prev, last_Task_Completed: false } })
        }
        return map[key]()
    }

    function blobToBase64(blob) {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }

    const handleExportButtonClick = async () => {
        try {
            const response = await DownloadPdfWorkOrder(state);
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `WorkOrder - ${state?.id}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            const outlookHref = `mailto:?subject=${encodeURIComponent('Work Order')}&body=${encodeURIComponent('Please find attached work order.')}&attachment=${encodeURIComponent(await blobToBase64(blob))}`;
            window.location.href = outlookHref;
        } catch (error) {
            console.error('Error exporting data:', error);
        }
    };
    const handleAccept = () => {
        setIsModalVisible(true);
    };

    const handleModalCancel = () => {
        // Handle logic when the user clicks "Cancel" in the modal
        setIsModalVisible(false);
    };

    const formatNote = (str) => {
        return str ? str.replace(/@\[(.*?)\]\(\d+\)/g, '<span style="color:#2963AD;">@$1</span>').trim() : "N/A"
    }


    useEffect(() => {
        setMode(localStorage?.getItem("pageMode"))
    }, [localStorage?.getItem("pageMode")]);


    useEffect(() => {
        CheckDeleteWo()
    }, [reload])


    useEffect(() => {
        getWorkOrder()
    }, [refreshState, reload, reloadState]);

    useEffect(() => {
        const fetchNotesData = async () => {
            try {
                const result = await getAllNotesWorkOrder(id);
                if (result?.httpStatus === 200) {
                    setNotesData(result?.data || []);
                } else {
                    // Handle API error if needed
                }
            } catch (error) {
                // Handle fetch error if needed
                console.error('Error fetching notes data:', error);
            }
        };

        fetchNotesData();
    }, [reloadPageByNotesModal, reloadState]);

    useEffect(() => {
        (async () => {
            const offset = 0, limit = 100000;
            let params = '?'.concat(seriliazeParams({ offset, limit }))
            let result = await hr.getAllEmployees({ params });
            if (result.httpStatus === 200) {
                setAllUsers(result?.data)
            }
        })();
    }, [])

    return (
        <PageLayout className="Liq-Container HRPortal EmployeeResult" id='newHireQueuePage'>
            <Grid className="PagesFrame">

                <PageHeader />
                <Grid container id="PageTitle">Locomotive Work Orders </Grid>

                <div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ flex: 16 }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <div style={{ flex: 16 }}>
                                    <Button
                                        onClick={() => {
                                            history.goBack();
                                        }}
                                        style={{
                                            background: 'white',
                                            color: Colors.mainBlue,
                                            borderRadius: '10px',
                                            fontWeight: "800",
                                            marginTop: '10px',
                                            marginBottom: ''
                                        }}
                                    >
                                        <CaretLeftOutlined />Back
                                    </Button>

                                </div>

                                {roleManager("employeeLookup", "sections", "closeWorkOrder") &&
                                    Data?.Status !== "Closed-WNC" && Data?.Status !== "Reviewed-Approved" && (
                                        <div style={{ marginTop: '10px' }}>
                                            {!(Data?.AssignRole == 9 && (haveAccessByRole([2, 10], "array"))) && (
                                                <WoOrderModalNC reload={reload} setReload={setReload} mode={mode} />
                                            )}
                                        </div>
                                    )}
                                <Button
                                    style={{
                                        background: 'white',
                                        color: Colors.mainBlue,
                                        borderRadius: '10px',
                                        fontWeight: "800",
                                        marginTop: '10px',
                                        marginRight: '5px',
                                        opacity: mode === "view-only" ? "0.5" : "1"
                                    }}
                                    onClick={handleExportButtonClick}
                                    disabled={mode === 'view-only' ? true : false}
                                >
                                    Export To Email
                                </Button>
                            </div>

                            {roleManager('LocomotiveWorkOrder', 'sections', 'DeleteListSheet') && showDeleteWo?.length !== 0 ?
                                <div style={{ display: 'flex', flexDirection: 'row-reverse', marginRight: '10px', marginTop: '10px' }}>
                                    <Button
                                        style={{ background: 'white', color: Colors.mainBlue, borderRadius: '10px', fontWeight: "800" }}
                                        onClick={ShowDeleteTable}
                                        disabled={mode === "view-only" ? true : false}
                                    >
                                        Deleted Tasks
                                    </Button>

                                </div> : ''}

                            <div style={{ marginTop: '20px' }}>
                                <div style={{ display: "flex", gap: "10px" }}>
                                    <p style={{ fontWeight: "600", width: "70px" }}>Equip ID</p>
                                    {mode === "view-only"
                                        ? <p>{Data?.EquipMaster?.EquipUID}</p>
                                        : <Link to={{
                                            pathname: '/LocomotiveEdit',
                                            state: { data: { id: Data?.EquipMaster?.id } }
                                        }}>
                                            <p style={{ color: 'blue' }}>{Data?.EquipMaster?.EquipUID}</p>
                                        </Link>

                                    }
                                </div>

                                <div style={{ display: "flex", gap: "50px" }}>
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        <p style={{ fontWeight: "600", width: "70px" }}>Model</p>
                                        <p style={{ width: '100px' }}>{Data?.EquipMaster?.Loco_Model}</p>
                                    </div>

                                    <div style={{ display: "flex", gap: "10px" }}>
                                        <p style={{ fontWeight: "600", width: '110px' }}>Current Status:</p>
                                        <p>{Data?.EquipMaster?.status?.IS_Description || 'N/A'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{ flex: 3, marginRight: '20px' }}>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: 'right', border: '2px solid black ', borderRadius: "10px", paddingLeft: "5px", marginTop: '10px', width: '110%' }}>
                                <div style={{ display: "flex", gap: '40px' }}>
                                    <div style={{ fontWeight: "600", whiteSpace: "nowrap", padding: "0px", margin: "0px", fontSize: "13px", display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
                                        <p style={{ marginBottom: "0px", width: "100%", textAlign: 'left' }}>Last Updated</p>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginTop: "10px", width: "100%" }}>
                                        <p style={{ color: "gray", flexWrap: "nowrap", }}>{moment(Data?.updatedAt).utc().format("MM-DD-YYYY")}</p>
                                    </div>
                                </div>
                                <div style={{ display: "flex", gap: '22px', width: '100%' }}>
                                    <div style={{ fontWeight: "600", whiteSpace: "nowrap", padding: "0px", margin: "0px", fontSize: "13px", display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
                                        <p style={{ marginBottom: "0px", width: "100%", textAlign: 'left' }}>Last Updated By</p>
                                    </div>
                                    <div name={"ID"} style={{ display: "flex", alignItems: "center", marginTop: "10px", width: "100%", paddingRight: '2px' }}>
                                        <p style={{ color: "gray", whiteSpace: "nowrap", width: '150px' }}>{showText(Data?.LastUpdby?.firstName + " " + Data?.LastUpdby?.lastName)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Divider className='dividerclass' />

                <div style={{ marginTop: "10px" }}>
                    <Row>
                        <Col md={13}>
                            <div style={{ marginTop: '10px', display: "flex", flexDirection: "column", gap: "10px" }}>
                                {Fields?.map((item, index) =>
                                    <div style={{ display: "grid", gridTemplateColumns: "50% 50%" }}>
                                        <div style={{ marginBottom: "0px", display: "flex", alignItems: "center", gap: "10px" }}>
                                            <span style={{ fontWeight: "600" }}>{item.name}</span>
                                            {item?.edit && (
                                                roleManager("LocomotiveWorkOrder", "sections", "work_order_edits") && (
                                                    <span
                                                        className="EditIcon"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            setModalData({ label: item, values: Data });
                                                            onClickEditInfo(item?.key);
                                                        }}
                                                    />
                                                )
                                            )}
                                        </div>
                                        {item?.action === "redirect"
                                            ? <span
                                                onClick={() => history.push(`/LocomotiveTicketEdit`, { id: Data?.TckId })}
                                                style={{ color: 'blue', cursor: "pointer" }}
                                            >
                                                {workOrderByID[item?.key] || "N/A"}
                                            </span>
                                            : <span>{workOrderByID[item?.key] || "N/A"}</span>
                                        }

                                    </div>
                                )}
                            </div>
                        </Col>
                        <Col md={11}>
                            <Row style={{ marginBottom: '10px' }}>
                                <Col md={9}>
                                    <h3 style={{ fontWeight: 'bold' }}>Previous Notes</h3>
                                </Col>

                                <Col md={12}>
                                    <Button type="primary" onClick={openNotesModal}
                                        style={{
                                            background: '#2863ad', color: "white",
                                            width: "fit-content", borderRadius: "10px",
                                        }}
                                        disabled={(Data?.AssignRole === 9 && haveAccessByRole(2)) || (Data?.AssignRole === 9 && haveAccessByRole(10))}
                                    >
                                        <PlusOutlined />
                                        Add Notes
                                    </Button>
                                </Col>
                            </Row>
                            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                {notesData.map((note) => (
                                    <div key={note.id}>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: `${moment?.utc(note.createdAt).format("MM/DD/YYYY")} - ${note?.Employee?.firstName} ${note?.Employee?.lastName} : ${formatNote(note?.WoNote)}`
                                            }}
                                        />
                                    </div>
                                ))}
                                {/* <Table
                                        dataSource={notesData}
                                        pagination={false}
                                        columns={columnPreviousNotes}
                                        scroll={{ x: 'max-content' }}
                                    /> */}
                            </div>
                        </Col>
                    </Row>
                </div>

                {
                    ((Data?.Assignedto !== null && Data?.Assignedto !== 'N/A') && (Data?.ScheduleDate !== null && Data?.ScheduleDate !== 'N/A')) ||
                        ((Data?.AssignedtoContractor !== null && Data?.AssignedtoContractor !== 'N/A') && (Data?.ScheduleDate !== null && Data?.ScheduleDate !== 'N/A'))
                        ? (
                            <div style={{ marginTop: '15px', marginBottom: '15px' }}>
                                {/* {roleManager("LocomotiveWorkOrder", "sections", "ApproveORreject") && ( */}

                                <Row>
                                    {Data?.complete === true && Data?.approve === true && Data?.Status === 'Cmpl Pending Review' ? (

                                        <>
                                            {roleManager("LocomotiveWorkOrder", "sections", "ApproveORreject") && (
                                                <>
                                                    <Col md={20} xs={19}>
                                                        <h2 style={{ fontWeight: '600', fontSize: '20px' }}> Work Order Task </h2>
                                                    </Col>

                                                    <Col md={2} xs={3}>
                                                        <Button
                                                            style={{
                                                                background: Data?.approve ? '#2863ad' : 'gray',
                                                                color: "white",
                                                                borderRadius: "10px ",
                                                                // marginRight: '10px'
                                                            }}
                                                            key='accept'
                                                            onClick={handleAccept}

                                                            // onClick={() => handleStatus("accept")}
                                                            disabled={Data?.approve === false}
                                                        >
                                                            Approve
                                                        </Button>
                                                    </Col>
                                                    <Col md={2} xs={2}>
                                                        <Button
                                                            style={{
                                                                background: Data?.approve ? '#2863ad' : 'gray',
                                                                color: "white",
                                                                borderRadius: "10px ",
                                                                marginLeft: '10px'
                                                            }}
                                                            key='reject'
                                                            onClick={() => handleStatus("reject")}
                                                            disabled={Data?.approve === false}
                                                        >
                                                            Reject
                                                        </Button>
                                                    </Col>
                                                </>)}
                                        </>
                                    ) : (
                                        <>

                                            <div style={{ width: '89%' }}>
                                                <h2 style={{ fontWeight: '600', fontSize: '20px' }}>Work Order Task</h2>
                                            </div>
                                            {(Data?.Status !== "Reviewed-Approved" && Data?.Status !== "Cmpl Pending Review") && (
                                                <div style={{ width: '11%' }}>
                                                    <Button
                                                        style={{
                                                            background: Data?.complete ? '#2863ad' : 'gray',
                                                            color: "white",
                                                            borderRadius: "10px",
                                                            opacity: mode === "view-only" ? "0.4" : "1"
                                                        }}
                                                        key='complete'
                                                        onClick={() => handleStatus("complete")}
                                                        disabled={mode === "view-only" ? true : Data?.complete ? false : true}
                                                    >
                                                        Complete WO
                                                    </Button>
                                                </div>
                                            )}

                                        </>
                                    )}
                                </Row>
                                {/* )} */}
                            </div>
                        ) : null
                }


                {((Data?.Assignedto !== null && Data?.Assignedto !== 'N/A') && (Data?.ScheduleDate !== null && Data?.ScheduleDate !== 'N/A')) ||
                    ((Data?.AssignedtoContractor !== null && Data?.AssignedtoContractor !== 'N/A') && (Data?.ScheduleDate !== null && Data?.ScheduleDate !== 'N/A')) ? (
                    <div>
                        <LocomotiveTable
                            setWorkOrderData={setWorkOrderData}
                            workOrderData={workOrderData}
                            reload={reload}
                            setReload={setReload}
                            reloadState={reloadState}
                            status={Data?.Status}
                            workOrder={Data}
                            mode={mode} />
                    </div>
                ) : null}
            </Grid>
            {/* <LocomotiveWorkOrderModal
                open={openModal}
                close={HandleModal}
                data={modalData}
                TicketIdCategory={ticketId}
            /> */}
            {/* <LocomotiveTicketModal open={''} close={HandleModal} data={modalData} TicketTypeId={ticketId} /> */}

            <ConfirmModal
                visible={isModalOpen}
                closeModal={() => setIsModalOpen(false)}
                handleOk={ConfirmModalSubmit} />
            <ModalDeleteWoTable
                showModal={ShowDeleteTable}
                handleOk={DeleteTablehandleOk}
                handleCancel={DeleteTablehandleCancel}
                isModalOpen={isModalOpenDeleteTable}
                data={updateData}
                setData={setUpdateData}
                apiData={apiData}
                defaultOption={'7'}
            />
            <AcceptModal
                visible={isModalVisible}
                onOk={() => {
                    handleStatus('accept')
                    setIsModalVisible(false)
                }}
                onCancel={handleModalCancel}
                setAllSelectedCauseCodes={setAllSelectedCauseCodes}
                selectedCauseCode={selectedCauseCode}
                setSelectedCauseCode={setSelectedCauseCode}
            />

            <NotesModalUpdated
                showModal={isModalOpenNotes}
                closeModal={closeModalNotes}
                data={Data}
                users={allUsers}
                setReloadPageByNotesModal={setReloadPageByNotesModal}
            />
            <LastTaskCompletedModal
                open={isModalsOpen?.last_Task_Completed}
                close={() => onCloseModals("last_Task_Completed")}
                modalData={modalData}
                setReloadState={setReloadState}
            />
            <TicketCategoryModals
                open={isModalsOpen?.ticket_Category}
                close={() => onCloseModals("ticket_Category")} ticket_id={ticketId}
                modalData={modalData}
                setReloadState={setReloadState}
            />
            <WODescriptionModal
                open={isModalsOpen?.wo_Discription}
                close={() => onCloseModals("wo_Discription")}
                modalData={modalData}
                setReloadState={setReloadState}
            />
            <WOAssignedToModal
                open={isModalsOpen?.wo_Assigned_To}
                close={() => onCloseModals("wo_Assigned_To")}
                modalData={modalData}
                setReloadState={setReloadState}
            />
            <DateScheduledModal
                open={isModalsOpen?.wo_Schedule_Date}
                close={() => onCloseModals("wo_Schedule_Date")}
                modalData={modalData}
                setReloadState={setReloadState}
            />

        </PageLayout>
    )
}

export default LocomotiveWorkOrderEdit
